import { setSessionClientInformation } from "app/utils/utility.service";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getSingleClient } from "../clients/clients.service";
import "./HomePurchase.scss";
import { useMediaQuery } from "react-responsive";
import { NumericFormat } from "react-number-format";
const HomePurchaseStep1 = () => {
	const [rent, setRent] = useState(null);
	const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const clientId = searchParams.get("clientid");
    const {state} = useLocation();
    const option = state?.option;
	const handleClick = (e) => {
		e.preventDefault();
		//navigate(`/home-purchase/step2/?rent=${rent}&clientid=${clientId}`);
        navigate(`/home-purchase/step2/`,{ state: { rent: rent , clientid:clientId, option:"First"} });
	};
	const handleInputChange = (e) => {
        let value = e.target.value.replace(/[$,]/g, '');
		// const re = /^[0-9\b]+$/;
		if (value !== "") {
			setRent(parseFloat(value));
		}
	};
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
      })
    const isTablet = useMediaQuery({
        query: '(min-width: 768px) and (max-width: 1024px)'
      });
    useEffect(async ()=>{
        if(clientId) {
            const record  = await getSingleClient(clientId);
            setSessionClientInformation(record);
        }
    },[clientId])
	return (
        <div className="center-align">
            <div className="HomePurchaseRentForm">
                <h2>How to position a home purchase?</h2>
                <div>
                    <h3>
                        Typical first time home buyer's rent.
                        <br />
                        Let's start with rent as housing expense.
                    </h3>
                </div>
                <div className="flex justify-content-center">
                    <div className={`grid ${isTablet ? "w-100" : ""}`}>
                        <div className="col-12 md:col-12 lg:col-4 content">
                            <div className="rent-label">
                                <label>Enter Rent</label>
                            </div>
                        </div>
                        <div className="widthcls-mobile">
                            <form onSubmit={handleClick} autoComplete="off">
                                <div className="col-12 md:col-12 lg:col-12 content">
                                    <div className="mb-4 field">
                                        <div className="p-inputgroup">
                                            <NumericFormat
                                                className="input-field"
                                                style={{"width":"100%"}}
                                                thousandSeparator=","
                                                autoFocus
                                                autoComplete="off"
                                                required={true}
                                                name="rent" prefix="$ "
                                                value={rent}
                                                onBlur={(e) => {
                                                handleInputChange(e);
                                                }}
                                                allowNegative={false}
                                                decimalScale={2}
                                            />
                                        </div>
                                        {/* <span className="p-input-icon-left">
                                        <i className="pi pi-dollar" />
                                        
                                    </span> */}
                                        {/* <small className="p-error block">
                                        Username is not available.
                                    </small> */}
                                    </div>

                                    <Button
                                        disabled={!rent || rent === ""}
                                        label="Next"
                                        className="p-button-raised p-button-warning p-button-lg"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div>Step 1</div>
            <Button
                onClick={handleClick}
                label="Step 2"
                className="p-button-raised p-button-warning p-button-lg"
            /> */}
        </div>
    );
};

export default HomePurchaseStep1;
